import React from 'react';
import { observer } from 'mobx-react-lite';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { useAppStateContext } from 'src/AppState/AppState';
import DatePicker from 'react-datepicker';
import { CloseIconWrapper } from './WelcomeBonusForm.style';
import { ErrorMessageBar, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent, FormWrapper, DatesWrapper, DateInputWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { WelcomeBonusFormState } from './WelcomeBonusForm.state';
import { OldSelect } from 'src/domains/layouts/shared/formComponents/Select/components/OldSelect';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const WelcomeBonusForm = observer(() => {
    const { welcomeBonusState } = useAppStateContext();
    const [ state ] = React.useState(() => new WelcomeBonusFormState(welcomeBonusState));
    const { preventDefault, onChangeEndDate, onBlurEndDate } = state;
    const {
        promoCodesForSelection,
        isLoading,
        errorMessage,
        duplicateError,
        invalidDates,
        isFormValid,
        isEditMode,
        handleSubmit,
        handleCancel,
        resetForm,
        endDate,
        minimumOddsModel,
        minimum_odds,
        minimumOddsStatus,
        bonusIdModel,
        bonus_id,
        bonusIdStatus,
        depositAmountModel,
        deposit_amount,
        depositAmountStatus,
        bonusAmountModel,
        bonus_amount,
        bonusAmountStatus,
        betAmountModel,
        bet_amount,
        betAmountStatus,
        validDaysModel,
        valid_days,
        validDaysStatus,
        welcomeBonusNameModel,
        welcome_bonus,
        welcomeBonusNameStatus,
        promo_code,
        clearDate,
    } = welcomeBonusState;

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new welcome bonus' editModeLabel='Edit welcome bonus' resetForm={resetForm}/>
            <FormComponent onSubmit={preventDefault}>
                <Loader isActive={isLoading}/>

                {!!errorMessage && <ErrorMessageBar>{errorMessage}</ErrorMessageBar>}

                <OldInput
                    label='Name (Max 30 chracters)'
                    status={welcomeBonusNameStatus}
                    formInputState={welcome_bonus}
                    model={welcomeBonusNameModel}/>

                <OldInput
                    label='Bonus ID (Max 30 characters)'
                    status={bonusIdStatus}
                    formInputState={bonus_id}
                    model={bonusIdModel}
                    readOnly={isEditMode}
                />

                <OldInput
                    label='Minimum Odds (Decimal)'
                    status={minimumOddsStatus}
                    formInputState={minimum_odds}
                    model={minimumOddsModel}/>

                <OldInput
                    label='Minimum Deposit Amount (£)'
                    status={depositAmountStatus}
                    formInputState={deposit_amount}
                    model={depositAmountModel}
                    currency='£'
                />

                <OldInput
                    label='Minimum Bet Amount (£)'
                    status={betAmountStatus}
                    formInputState={bet_amount}
                    model={betAmountModel}
                    currency='£'
                />

                <OldInput
                    label='Maximum Bonus Amount (£)'
                    status={bonusAmountStatus}
                    formInputState={bonus_amount}
                    model={bonusAmountModel}
                    currency='£'
                />


                <OldSelect selectOptions={promoCodesForSelection} stateValue={promo_code} defaultText='Select Promo Code' label='Promo Code' />

                <OldInput
                    label='Free Bet Credits Valid For (Days)'
                    status={validDaysStatus}
                    formInputState={valid_days}
                    model={validDaysModel}/>

                <DatesWrapper>
                    <DateInputWrapper>
                        <InputLabel>Bonus active until *</InputLabel>
                        <DatePicker
                            selected={endDate}
                            onChange={onChangeEndDate}
                            onBlur={onBlurEndDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                        />
                        <CloseIconWrapper onClick={clearDate}/>
                    </DateInputWrapper>
                </DatesWrapper>
                {invalidDates ?  <ErrorMessageBar>Please provide end date or number of days validation</ErrorMessageBar>  : null}
                {duplicateError === null ? null : <ErrorMessageBar>{duplicateError}</ErrorMessageBar>}

                <FormButtons
                    onCreate={handleSubmit}
                    onUpdate={handleSubmit}
                    onCancel={handleCancel}
                    isEditMode={isEditMode}
                    isCreateDisabled={!isFormValid}
                    isUpdateDisabled={!isFormValid}
                />
            </FormComponent>
        </FormWrapper>
    );
});

